import React, { useEffect, useState } from 'react';
import classes from "./OtpPage.module.css";
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import OTPInput from 'react-otp-input';
import { SendOtpAPI, VerifyOtpAPI } from '../api/api';
import BackgroundLayout from '../Components/BackgroundLayout';
import { motion, useAnimationControls } from "framer-motion";

const OtpPage = () => {

    const [otp, setOtp] = useState("");
    const [timer, setTimer] = useState(120);
    const navigate = useNavigate();
    const [msisdn, setMsisdn] = useState("");
    const [extRef, setExtRef] = useState(null);
    const [referenceNo, setReferenceNo] = useState(null);
    const [resend, setResend] = useState(false);
    const [resendLoading, setResendLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const location = useLocation();

    const variants = {
        hidden: {
            opacity: 0,
            scale: 0,
        },
        visible: {
            opacity: 1,
            scale: 1,
        },
    };

    const controls = useAnimationControls();

    useEffect(() => {
        controls.start("visible");
    }, []);

    useEffect(() => {
        if (location?.state?.msisdn) {
            setMsisdn(location?.state?.msisdn);
            setExtRef(location?.state?.extRef);
            setReferenceNo(location?.state?.referenceNo);
        }
        else {
            navigate("/");
        }
    }, [location]);

    const handleFormSubmission = async () => {
        try {
            if (otp.length <= 5) {
                return;
            }
            setLoading(true);
            const response = await VerifyOtpAPI(msisdn, otp, referenceNo, extRef);
            console.log(response, 'response---');
            setLoading(false);
            navigate("/subscription-processing", {
                state: {
                    msisdn: msisdn
                }
            })
        } catch (error: any) {
            setLoading(false);
            console.log(error, 'error---');

            if (error?.response?.data?.status == 0) {
                toast.error("Wrong OTP");
            }
            else if (error?.response?.data?.status == 1) {
                toast.info("Subscribe Successfully");
                navigate("/low-balance");
            }
            else {
                toast.error("Something Went Wrong!");
            }
        }
    }

    const resendOtpHandler = async () => {
        try {
            setResendLoading(true);

            const response = await SendOtpAPI(msisdn);
            setTimer(120);
            setResendLoading(false);
            if (response?.data?.status == 1) {
                setResend(true);
                setOtp("");
                toast.success("OTP Resend Successfully!");
            }
            else {
                toast.error("Failed to Send OTP!");
            }
        } catch (error) {
            setResendLoading(false);
            toast.error("Something Went Wrong!");
        }
    }

    useEffect(() => {
        const countdown = setInterval(() => {
            setTimer((prevTimer) => prevTimer - 1);
        }, 1000);

        return () => {
            clearInterval(countdown);
        };
    }, []);

    useEffect(() => {
        if (timer <= 0) {
            navigate("/");
        }
    }, [timer]);


    return (
        <BackgroundLayout style={{padding:0}}>
            <motion.div
                layout
                variants={variants}
                initial="hidden"
                animate={controls}
                transition={{
                    type: "spring",
                    stiffness: 700,
                    damping: 30,
                }}
                className={classes.auth_modal}
            >
                <div className={classes.auth_sub_modal}>
                    <motion.div className={classes.form_modal}>
                        <img src="/assets/images/logo2.png" alt="uvmovie" className={classes.logo} />
                        {/* <p className={classes.title}>Subscribe Service</p> */}


                        <div className={classes.otp_container}>


                            <div className={classes.otp_description}>
                                <h2 className={classes.title}>OTP Verification</h2>
                                <p className={classes.text}>
                                    We have sent {resend && "another"} one time pin to
                                    <span className={classes.bold}> +94 {msisdn} </span>
                                    via SMS.
                                </p>
                            </div>

                            <div className={classes.otp_input_container}>
                                <OTPInput
                                    value={otp}
                                    shouldAutoFocus
                                    onChange={setOtp}
                                    numInputs={6}
                                    renderSeparator={<span className={classes.gap}></span>}
                                    renderInput={(props) => (
                                        <input {...props} type="number" className={classes.input_box} />
                                    )}
                                />
                            </div>

                            <div className={classes.time_container}>
                                <p className={classes.time_text}>Time remaining: {timer} seconds</p>
                            </div>

                            {(loading || resendLoading) ? <div style={{ width: "100%", display: "grid", placeContent: "center" }}>
                                <p>Loading....</p>
                            </div> : (
                                <div className={classes.btn_container}>
                                    <button
                                        type="button"
                                        className={classes.confirm_btn}
                                        disabled={loading}
                                        onClick={handleFormSubmission}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        type="button"
                                        className={classes.resend_btn}
                                        disabled={resendLoading}
                                        onClick={resendOtpHandler}
                                    >
                                        Resend OTP
                                    </button>
                                </div>
                            )}

                        </div>


                    </motion.div>
                </div>
            </motion.div>

        </BackgroundLayout>
    )
}

export default OtpPage